import { Box, Chip } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import Flex from "../../../../../components/Flex";
import Input from "../../../../../components/Input";
import OutlineCard from "../../../../../components/OutlineCard";
import Text from "../../../../../components/Text";
import DeleteIcon from "../../../../../components/app/DeleteIcon";
import StyledButtonV2 from "../../../../../components/app/StyledButtonV2";
import { useSnackbar } from "../../../../../hooks/useSnackbar";
import { useAddProviderGroupEmailVerification } from "../../../../../queries/practice-setting/configuration/use-add-provider-group-email-verification";
import { getXtenantId, showToastOnApiCall } from "../../../../../utils/utils";

const emailValidationSchema = Yup.object().shape({
  senderEmailId: Yup.string()
    .nullable()
    .email("Please enter a valid email address."),
});
interface EmailIdVerificationFormProps {
  onVerify: () => void;
  providerDetails?: any;
  configurationDetails?: any;
}
interface SenderEmailFormValues {
  senderEmailId: string;
}

const SENDER_EMAIL_INITIAL_VALUES: SenderEmailFormValues = {
  senderEmailId: "",
};

const EmailIdVerificationForm = ({
  onVerify,
  providerDetails,
  configurationDetails,
}: EmailIdVerificationFormProps) => {
  const params = useParams();
  const showSnackbar = useSnackbar();

  const { mutateAsync: addSenderEmail } =
    useAddProviderGroupEmailVerification();

  const formik = useFormik<SenderEmailFormValues>({
    initialValues: SENDER_EMAIL_INITIAL_VALUES,
    validationSchema: emailValidationSchema,
    onSubmit: (values) => {
      const payload = {
        email: values.senderEmailId,
        providerGroupId: (providerDetails?.data as any)?.uuid,
        xTENANTID: getXtenantId() ?? params?.providerGroupId ?? undefined,
      };

      showToastOnApiCall({
        apiCall: addSenderEmail(payload),
        showSnackbar,
        onSave: () => {
          onVerify();
          formik.resetForm();
        },
      });
    },
  });

  return (
    <OutlineCard>
      <Flex flexDirection="column" width="100%">
        <Flex
          justifyContent="space-between"
          alignItems="center"
          marginBottom="10px"
        >
          <Flex flex={1}>
            <Text fontSize="16px" fontWeight="600">
              Sender Email ID Verification
            </Text>
          </Flex>
        </Flex>

        <Flex flexDirection="column" gap={1}>
          <Flex alignItems="center" gap={0.5}>
            <Text fontSize="14px" color="text.secondary">
              Email ID:{" "}
              <Chip
                variant="outlined"
                size="small"
                color={"primary"}
                label={configurationDetails?.data?.emailId ?? "Not Verified"}
              />
            </Text>

            {/* <IconButton
              disabled={!configurationDetails?.data?.emailId}
              onClick={() => {
                formik.setFieldValue("senderEmailId", null);
                formik.submitForm();
              }}
            >
              <ClearIcon
                fontSize="small"
                color={
                  configurationDetails?.data?.emailId?.length === 0
                    ? "disabled"
                    : "error"
                }
              />
            </IconButton> */}
            <DeleteIcon
              disabled={configurationDetails?.data?.emailId?.length === 0}
              onClick={() => {
                formik.setFieldValue("senderEmailId", null);
                formik.submitForm();
              }}
            />
          </Flex>

          <Text fontSize="12px" color="text.secondary">
            This Email will Show When Sending Emails From Platform
          </Text>

          <Flex alignItems="center" gap="12px">
            <Box flex={1}>
              <Input
                error={
                  formik.touched.senderEmailId && formik.errors.senderEmailId
                    ? formik.errors.senderEmailId
                    : undefined
                }
                textFieldProps={{
                  placeholder: "Enter Sender Email ID",
                  disabled:
                    // !clearEmailId ||
                    configurationDetails?.data?.emailId?.length > 0,
                  name: "senderEmailId",
                  value: formik.values.senderEmailId,
                  onChange: formik.handleChange,
                  onBlur: formik.handleBlur,
                }}
              />
            </Box>
            <StyledButtonV2
              variant="contained"
              color="primary"
              disabled={
                // !clearEmailId ||
                formik.values?.senderEmailId?.trim()?.length === 0 ||
                !!formik.errors.senderEmailId ||
                configurationDetails?.data?.emailId?.length > 0
              }
              label="Verify"
              onClick={() => formik.handleSubmit()}
            />
          </Flex>
        </Flex>
      </Flex>
    </OutlineCard>
  );
};

export default EmailIdVerificationForm;
